/**
 * Success Page - Shown after successful contribution
 * Uses backend-provided social sharing links
 */

import { Button, Input, useToast } from '@chakra-ui/react';
import { useContext } from 'react';
import { GlobalContext } from '../App';
import Header from './header';
import thankyou from '../assets/svgs/thank_you.svg';
import facebook from '../assets/svgs/facebook.svg';
import twitter from '../assets/svgs/twitter.svg';
import whatsapp from '../assets/svgs/whatsapp.svg';
import bg_p from '../assets/svgs/bg_pattern.svg';

function Success() {
    const toast = useToast();
    const campaign = useContext(GlobalContext);

    const resolvedCampaign = campaign?.get || (() => {
        try {
            const raw = localStorage.getItem('MOTITO');
            return raw ? JSON.parse(raw) : null;
        } catch {
            return null;
        }
    })();

    // Use backend-provided sharing URL or fallback to current campaign URL
    const sharingUrl = resolvedCampaign?.social_sharing?.direct || resolvedCampaign?.url || '';

    if (!resolvedCampaign) {
        return (
            <div>
                <Header />
                <div className='max-w-[500px] px-4 mx-auto space-y-4 mt-16 text-center'>
                    <p className='text-xl font-bold text-[#2E384B]'>Payment complete</p>
                    <p className='text-sm text-[#5C6278]'>
                        Thanks for supporting this campaign. We couldn&apos;t load the campaign details on this screen.
                    </p>
                    <Button
                        className=' text-white hover:bg-opacity-90 bg-[#0B419C]'
                        onClick={() => window.location.assign('https://motito.co')}
                    >
                        Continue
                    </Button>
                </div>
            </div>
        );
    }

    return (
        <div>
            <img className='absolute max-w-[500px] mx-auto object-fill' src={bg_p} alt="" />
            <Header />

            <div className='max-w-[500px] px-4 mx-auto space-y-4 mt-3 mb-10 '>
                <div className='text-center w-fit mx-auto'>
                    <img src={thankyou} alt="Thank you" />
                </div>
                <div className='text-center'>
                    <p className='text-2xl font-bold text-[#2E384B]'>Thank you for your donation!</p>
                </div>
                <div className='text-center'>
                    <p>
                        You've successfully contributed GHS <span className='font-bold'>{resolvedCampaign?.user_data?.amount?.toLocaleString() ?? 0.0}</span>, to <span className='font-bold'>{resolvedCampaign?.user_name} </span> fundraising. A receipt has been sent as an SMS to your phone number.
                    </p>
                </div>
                <div className='text-center'>
                    <p className='text-xl font-bold text-[#2E384B]'>Help spread the word.</p>
                    <p>
                        You can share this campaign to spread the word and help <span className='font-bold'>{resolvedCampaign?.user_name} </span> reach his target faster.
                    </p>
                </div>

                <div>
                    <p className='text-sm'>Copy Link </p>
                    <div className='flex gap-3'>
                        <Input readOnly value={sharingUrl} className='border p-4 rounded-md flex-auto' />
                        <Button className=' text-white hover:bg-opacity-90 bg-[#0B419C]' onClick={() => {
                            navigator.clipboard.writeText(sharingUrl);
                            toast({
                                title: 'Copied!',
                                description: "Sharing link has been copied",
                                position: 'top',
                                duration: 2000,
                            })
                        }}>
                            Copy
                        </Button>
                    </div>
                </div>

                <div className='flex gap-8 w-fit mx-auto text-center'>
                    <div onClick={() => {
                        // Use backend-provided WhatsApp link or fallback
                        const whatsappUrl = resolvedCampaign?.social_sharing?.whatsapp || `https://wa.me/?text=${encodeURIComponent(sharingUrl)}`;
                        window.open(whatsappUrl, '_blank')
                    }} className='w-fit cursor-pointer'>
                        <img className='mx-auto' src={whatsapp} alt="WhatsApp" />
                        <p>WhatsApp</p>
                    </div>

                    <div onClick={() => {
                        // Use backend-provided Facebook link or fallback
                        const facebookUrl = resolvedCampaign?.social_sharing?.facebook || `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(sharingUrl)}`;
                        window.open(facebookUrl, '_blank')
                    }} className='w-fit cursor-pointer'>
                        <img className='mx-auto' src={facebook} alt="Facebook" />
                        <p>Facebook</p>
                    </div>

                    <div onClick={() => {
                        // Use backend-provided Twitter link or fallback
                        const twitterUrl = resolvedCampaign?.social_sharing?.twitter || `https://twitter.com/intent/tweet?url=${encodeURIComponent(sharingUrl)}`;
                        window.open(twitterUrl, '_blank')
                    }} className='w-fit cursor-pointer'>
                        <img className='mx-auto' src={twitter} alt="Twitter" />
                        <p>Twitter</p>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Success
